import { render } from "./VUEPrimoAccesso.vue?vue&type=template&id=76721706"
import script from "./VUEPrimoAccesso.vue?vue&type=script&lang=js"
export * from "./VUEPrimoAccesso.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__